import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FadeInDirective } from '../../directives/fade-in.directive';

@Component({
  selector: 'app-confirm-email',
  standalone: true,
  imports: [CommonModule, FadeInDirective],
  templateUrl: './confirm-email.component.html'
})
export class ConfirmEmailComponent implements OnInit {
  confirmationState: 'loading' | 'success' | 'error' = 'loading';
  status: string = 'Trwa potwierdzanie...';
  confirmationTitle: string = 'Potwierdzanie adresu e-mail';

  constructor(private route: ActivatedRoute, private http: HttpClient) {}

  ngOnInit(): void {
    const guid = this.route.snapshot.queryParamMap.get('guid');
    if (guid) {
      this.http.get(`/api/confirm-email/?guid=${guid}`).subscribe({
        next: (res: any) => {
          this.confirmationState = 'success';
          this.status = 'Twój adres e‑mail został pomyślnie potwierdzony.<br /><br />Bądź na bieżąco z tym, co dzieje się w projekcie Juno Audit – zapraszamy do śledzenia nas!';
          console.log(this.status);
          this.confirmationTitle = 'Adres e-mail potwierdzony!';
        },
        error: (err) => {
          this.confirmationState = 'error';
          this.status = 'Niestety podczas potwierdzania adresu e-mail wystąpił błąd. Proszę spróbować ponownie później.';
          this.confirmationTitle = 'Błąd potwierdzenia adresu e-mail';
        }
      });
    } else {
      this.confirmationState = 'error';
      this.status = 'Brak GUID w linku.';
      this.confirmationTitle = 'Błąd potwierdzenia adresu e-mail';
    }
  }
}
